import { useParams } from "react-router-dom"
import HomePage from "./HomePage/HomePage"
import GuideAndFAQPage from "./GuideAndFAQ/GuideAndFAQPage"
import PrivacyPolicy from "./PrivacyPolicy/PrivacyPolicy"
import TermsAndConditions from "./TermsAndConditions/TermsAndConditions"
import ShippingAndDelivery from "./ShippingAndDelivery/ShippingAndDelivery"


export default function PageDetails() {
    var { id } = useParams()

    return(
        <>
        {id==1?<HomePage/>:id==2?<GuideAndFAQPage/>:id==3?<ShippingAndDelivery/>:id==4?<PrivacyPolicy/>:<TermsAndConditions/>
        }
        </>
    )
}